import React, { PropTypes } from 'react';
import { FormattedMessage } from 'react-intl';
import BorrowingHeader from '../../shared/BorrowingHeader';
import BorrowingEmptyContentPanel from '../../shared/BorrowingEmptyContentPanel';
import { MessagesIcon } from '@bibliocommons/base-icons';

export default function AccountMessagesEmptyContentPanel({ fetching }) {
  return (
    <div className="cp-recentlyreturned">
      <div className="title-row">
        <BorrowingHeader
          headingKey="section_title_messages"
          taglineKey="section_tagline_messages" />
        <BorrowingEmptyContentPanel
          className="cp-recentlyreturned-empty-content-panel"
          fetching={fetching}
          showStaffPicksLink={false}
          helpPage="040settings/005privacy-settings"
          icon={<MessagesIcon />}
          title={<FormattedMessage id="empty_messages" />} />
      </div>
    </div>
  );
}

AccountMessagesEmptyContentPanel.propTypes = {
  fetching: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/borrowing/accountmessages/AccountMessagesEmptyContentPanel/AccountMessagesEmptyContentPanel.jsx